import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    DateField,
    EditButton,
    Filter,
    TextInput,
    TopToolbar,
    CreateButton,
    RefreshButton,
    useTranslate,
} from 'react-admin';
import { Box } from '@mui/material';
import { BrandDeleteWithConfirmButton } from './BrandDeleteWithConfirmButton';

const VehicleBrandsFilter = (props: any) => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <TextInput
                label={translate('ra.action.search')}
                source="search"
                alwaysOn
            />
        </Filter>
    );
};

const ListActions = () => (
    <TopToolbar>
        <CreateButton />
        <RefreshButton />
    </TopToolbar>
);

export const VehicleBrandsList = () => {
    const translate = useTranslate();

    return (
        <Box sx={{ position: 'relative' }}>
            <List
                filters={<VehicleBrandsFilter />}
                actions={<ListActions />}
                empty={false}
                perPage={25}
                sort={{ field: 'createdAt', order: 'DESC' }}
                title={translate('resources.vehicle-brands.name', { _: 'Vehicle Brands' })}
                sx={{
                    '& .RaList-content': {
                        backgroundColor: '#FAFAFA',
                    },
                }}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={false}
                    sx={{
                        '& .RaDatagrid-headerCell': {
                            backgroundColor: '#F5F5F5',
                            fontWeight: 'bold',
                        },
                        '& .RaDatagrid-row': {
                            '&:hover': {
                                backgroundColor: '#F0F7FF',
                            },
                        },
                    }}
                >
                    <TextField
                        source="name"
                        label={translate('resources.vehicle-brands.fields.name', { _: 'Name' })}
                    />
                    <NumberField
                        source="model_count"
                        label={translate('resources.vehicle-brands.fields.modelCount', { _: 'Models' })}
                    />
                    <DateField
                        source="created_at"
                        label={translate('resources.vehicle-brands.fields.createdAt', { _: 'Created' })}
                        showTime
                    />
                    <EditButton label="" />
                    <BrandDeleteWithConfirmButton />
                </Datagrid>
            </List>
        </Box>
    );
};
